import { render, staticRenderFns } from "./MainMenuAsideComponent.vue?vue&type=template&id=89dc5ebc"
import script from "./MainMenuAsideComponent.vue?vue&type=script&lang=js"
export * from "./MainMenuAsideComponent.vue?vue&type=script&lang=js"
import style0 from "./MainMenuAsideComponent.vue?vue&type=style&index=0&id=89dc5ebc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports